import { createLanguageAssertion } from './src/createLanguageAssertion';

/**
 * Detect if string match ukrainian language.
 * Used BCP47 standard for locale names.
 */
export const isUkLanguageCode = createLanguageAssertion({ matches: [/^(uk(-[a-zA-Z]{2})?)$/] });
